module.exports = __webpack_public_path__ + "0ba77088c75dbe8f49b35384756ebe2a.pdf";